// src/components/Project.js

import React from 'react';
import { Link } from 'react-router-dom';
import styled from "styled-components";
function Project({ id, title, description, image, link }) {

	const StyledLink = styled(Link)`
  text-decoration: none;
  color: black;
  &:hover {
    color: black; 
	}
	@media (max-width: 768px) {
    font-size: 1.25rem; /* Change font size for smaller screens */
  }
`;
  return (
		<StyledLink to={link} target="_blank">
    <div>
      <img src={image} alt="" className="project-image" />
			<div className="title-container">
				<h2 className="font-semibold">{title}</h2>
      </div>
			<p className="text-gray-700">{description}</p>
    </div>
		</StyledLink>

  );
}

export default Project;
